import React from 'react';
import './Footer.css';
import { useHistory } from 'react-router-dom';


function Footer() {
    const history = useHistory();
    return (
        <div className="footer">
            <div className="footer__elements">
                <div className="footerElement">
                    <h3 onClick={(e) => history.push('/')} >Home</h3>
                    <h3 onClick={(e) => history.push('/ministries')} >Ministries</h3>
                    <h3 onClick={(e) => history.push('/sermons')} >Sermon</h3>
                </div>
                <div className="footer__webRules">
                    <p>Developed by : evatech Websites</p>
                </div>
            </div>
        </div>
    )
}

export default Footer
